// src/services/chat.service.js
import api from './api';

const chatService = {
  // Get all users you can chat with (same company, active)
  getChatableUsers: async () => {
    try {
      const response = await api.get('/chat/users');
      // Backend: { success, data: [users], message } — return data array directly
      return { data: response.data?.data || [] };
    } catch (error) {
      console.error('Error fetching chatable users:', error);
      throw error;
    }
  },

  // Get all conversations for current user
  getConversations: async () => {
    try {
      const response = await api.get('/chat/conversations');
      return { data: response.data?.data || [] };
    } catch (error) {
      console.error('Error fetching conversations:', error);
      throw error;
    }
  },

  // Start or get existing 1-1 conversation with a user
  startConversation: async (peerId) => {
    try {
      const response = await api.post('/chat/conversations', { peerId });
      return { data: response.data?.data };
    } catch (error) {
      console.error('Error starting conversation:', error);
      throw error;
    }
  },

  // Get paginated messages for a conversation
  getMessages: async (conversationId, page = 1, limit = 50) => {
    try {
      const response = await api.get(`/chat/conversations/${conversationId}/messages`, {
        params: { page, limit },
      });
      // Backend: { success, data: { messages, total, totalPages }, message }
      // Unwrap .data so hook can read .messages / .totalPages directly
      return response.data?.data || { messages: [], total: 0, totalPages: 0 };
    } catch (error) {
      console.error('Error fetching messages:', error);
      throw error;
    }
  },

  // Mark all messages in a conversation as read
  markAsRead: async (conversationId) => {
    try {
      const response = await api.post(`/chat/conversations/${conversationId}/read`);
      return response.data;
    } catch (error) {
      console.error('Error marking messages as read:', error);
      throw error;
    }
  },

  // Soft delete a message (only sender can delete)
  deleteMessage: async (messageId) => {
    try {
      const response = await api.delete(`/chat/messages/${messageId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting message:', error);
      throw error;
    }
  },

  // Get total unread message count across all conversations
  getUnreadCount: async () => {
    try {
      const response = await api.get('/chat/unread-count');
      return { data: response.data?.data || { count: 0 } };
    } catch (error) {
      console.error('Error fetching unread count:', error);
      throw error;
    }
  },
};

export default chatService;